module.exports = __webpack_public_path__ + "static/media/historia-ilustrada.71fa6dcc.webp";